import { record } from '../ability/context.js';
import { isUuid } from '../minigames/rows.js';

export const EXCHANGE_SCHEMA = 'janus.inventory.trade.v1';

/** Admit the final, composed exchange without drawing dice or changing its retry identity. */
export function exchangeValueRefusal(value: unknown): string | null {
  const command = record(value);
  if (!command || command.schema !== EXCHANGE_SCHEMA) return 'Invalid exchange schema';
  for (const key of ['actor_id', 'counterpart_id', 'operation_id']) {
    if (typeof command[key] !== 'string' || !isUuid(command[key])) return 'Invalid exchange identity';
  }
  // Encounter-less panels let the persisted actor row supply the encounter at save time.
  if (command.encounter_id !== '' && (typeof command.encounter_id !== 'string' || !isUuid(command.encounter_id))) return 'Invalid exchange identity';
  if (String(command.actor_id).toUpperCase() === String(command.counterpart_id).toUpperCase()) return 'Invalid exchange participants';
  if (!['trade', 'haggle', 'training'].includes(String(command.kind))) return 'Invalid exchange kind';
  const before = record(command.before);
  if (!before || (before.merchant_favor !== null && !Number.isInteger(before.merchant_favor))) return 'Invalid exchange before';
  const rows = record(command.plan)?.rows;
  if (!Array.isArray(rows) || rows.length > 128) return 'Invalid exchange logs';
  for (const raw of rows) {
    const row = record(raw), result = row?.roll_result ?? 0;
    if (!row || typeof row.roll_type_1 !== 'string' || new TextEncoder().encode(row.roll_type_1).length > 100
      || typeof (row.roll_type_2 ?? '') !== 'string'
      || !((typeof result === 'number' || typeof result === 'string' && result.trim() !== '') && Number.isFinite(Number(result)))
      || ![0, 1, 2].includes(row.roll_private as number ?? 0)) return 'Invalid exchange log';
    for (const key of ['roll_by', 'roll_to', 'roll_item_id']) {
      if (row[key] != null && row[key] !== '' && (typeof row[key] !== 'string' || !isUuid(row[key]))) return 'Invalid exchange log identity';
    }
  }
  return null;
}
